import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "header-text" }
const _hoisted_2 = {
  key: 1,
  class: "title"
}
const _hoisted_3 = {
  key: 2,
  class: "sub-text"
}

import { useI18n } from 'vue-i18n';
import {
  PermissionDeniedProps,
  PermissionDeniedPropsVariant,
} from '@/rex-components/PermissionDenied/PermissionDenied.type';


export default /*#__PURE__*/_defineComponent({
  __name: 'PermissionDenied',
  props: {
    showTitle: { type: Boolean, default: true },
    showSubTitle: { type: Boolean, default: true },
    variant: { default: PermissionDeniedPropsVariant.SOLID },
    noIcon: { type: Boolean, default: false }
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['permission-denied-wrapper', _ctx.variant])
  }, [
    _createElementVNode("p", _hoisted_1, [
      _renderSlot(_ctx.$slots, "header")
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([
        'content',
        {
          'content-height': !!_ctx.$slots.header,
        },
      ])
    }, [
      (!_ctx.noIcon)
        ? (_openBlock(), _createBlock(_component_BaseIcon, {
            key: 0,
            name: "lock"
          }))
        : _createCommentVNode("", true),
      (props.showTitle)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_2, _toDisplayString(_unref(t)('permission-denied')), 1))
        : _createCommentVNode("", true),
      (props.showSubTitle)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(t)('please-contact-admin-info')), 1))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})